import { createFileRoute } from '@tanstack/react-router'
import { FounderInvitePage } from '../../features/founder-invite/components/founder-invite-page'

export const Route = createFileRoute('/i/$token')({
  component: FounderInviteRoute,
})

function FounderInviteRoute() {
  const { token } = Route.useParams()
  return <FounderInvitePage token={token} />
}
